<template>
	<div class="content">
		<div class="h35 flex flex-align-center f16 fwb" style="border-bottom: 1px solid #dddddd;">「学员管理」</div>
		<div class="mt30 mx20">
			<div>
				<div style="width: 900px;float:left;">
					<!-- <el-input placeholder="请输入姓名、入学年份、手机号码" v-model="desc" class="input-with-select" @keyup.enter.native="search()">
						<template slot="prepend">条件</template>
						<el-button slot="append" icon="el-icon-search" :loading="loading" @click="search()"></el-button>
					</el-input> -->
					<el-input style="width: 400px;margin-right: 10px;" placeholder="请输入内容" clearable v-model="desc" class="input-with-select" @keyup.enter.native="search()">
						<el-select v-model="active" slot="prepend" placeholder="请选择" style="width: 100px;">
							<el-option :label="item.text" :value="index" v-for="(item,index) in category" :key="index"></el-option>
						</el-select>
					</el-input>

					<el-date-picker
						style="width: 150px;"
						v-model="minAttendanceYearGe"
						type="year"
						placeholder="入学开始年份"
						value-format="yyyy">
					</el-date-picker>
					-
					<el-date-picker
						style="width: 150px;"
						v-model="minAttendanceYearLe"
						type="year"
						placeholder="入学截至年份"
						value-format="yyyy">
					</el-date-picker>

					<el-button type="primary" style="margin-left: 10px;" icon="el-icon-search" :loading="loading" @click="search()">查询</el-button>
				</div>
				<div style="float:right;">
					<el-button type="primary" v-if="token" @click="toPage('/add-student')">新增</el-button>
				</div>
			</div>
			<div style="clear: both;"></div>
			<!-- table -->
			<el-table class="mt20" :data="list" stripe v-loading="isLoading" border style="width: 100%;" :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#000000', fontSize: '16px' }">
			    <el-table-column prop="code" label="编号" width="180" align="center"></el-table-column>
			    <el-table-column prop="name" label="学生姓名" width="140" align="center"></el-table-column>
			    <el-table-column prop="minAttendanceYear" label="入学年份" width="140" align="center"></el-table-column>
			    <el-table-column prop="minSchoolName" label="就读院校" align="center"></el-table-column>
			    <el-table-column prop="minMajor" label="专业" align="center"></el-table-column>
				<el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
			    <el-table-column label="操作" width="170" align="center">
					<template slot-scope="scope">
						<div class="flex-text">
							<el-button type="primary" size="mini" @click="edit(scope.row.id)">详情</el-button>
							<el-button type="danger" size="mini" @click="del(scope.row.id)">删除</el-button>
						</div>
					</template>
				</el-table-column>
				
				<!-- 暂无数据 -->
				<template #empty>
					<el-empty description="暂无数据" :image-size="120"></el-empty>
				</template>
			</el-table>
			
			<!-- 分页 -->
			<div class="mt20 flex flex-pack-justify" v-if="list.length">
				<div></div>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizeArr" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
import { MessageBox } from 'element-ui';
export default {
	name: 'student',
	data(){
		return{
			minAttendanceYearGe: '',
			minAttendanceYearLe: '',
			active: 0,
			desc: '',
			loading: false,  // 搜索按钮loading
			list: [],
		}
	},
	computed: {
		category(){
			return [
				{ text: '姓名', key: 'nameLike' },
				{ text: '手机号', key: 'phoneLike' },
			]
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		
		this.isLoading = true
		this.getUser()
		this.getData()
	},
	activated() {
		this.isLoading = true
		this.getData()
	},
	methods: {
		async getData(){
			let params = {
				pageNum: this.page,
				pageSize: this.page_size,
				minAttendanceYearGe: this.minAttendanceYearGe,
				minAttendanceYearLe: this.minAttendanceYearLe
			}
			params[this.category[this.active].key] = this.desc
			this.$http.post('/api/webs/student2/getPage', params)
			    .then(response => {
			        let res = response.data
					this.loading = false
					this.isLoading = false
					this.isReady = true
					if(res!=null){
						this.totalCount = res.total
						this.list = res.list
					}
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		search(){
			if(!this.token) return EventBus.$emit('show-login', true)
			// if(!this.desc) return this.$message({ message: '请输入专业名称', type: 'warning' })
			this.loading = true
			this.isReady = false
			this.list = []
			this.getData()
		},
		handleSizeChange(val) {
			this.page_size = val
			this.isLoading = true
			this.getData()
		},
		handleCurrentChange(val) {
			this.page = val
			this.isLoading = true
			this.getData()
		},
		edit(id){
			this.toPage('/add-student?id='+id)
		},
		del(id){
			MessageBox.confirm('删除数据，是否继续？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
			.then(() => {
				this.$http.post('/api/webs/student2/del', {id:id})
				.then(response => {
					let res = response
					this.getData()
					this.$message({ message: '删除学员成功', type: 'success' })
				})
				.catch(error => {
					console.error(error)
				})
			})
			.catch(() => {
				// 用户点击取消，取消删除
				// this.$message.info('已取消删除');
			});
		},
		toPage(e){
			this.$router.push(e)
		}
	}
}
</script>

<style>

</style>